import { Modal, Pressable, StyleSheet, View } from "react-native";

import { GText } from "@/components/g-text";
import { colors } from "@/constants/colors";

export interface BottomSheetOption {
  label: string;
  onPress: () => void;
}

interface Props {
  onClose: () => void;
  options: BottomSheetOption[];
  visible: boolean;
}

export function BottomSheet({ onClose, options, visible }: Props) {
  return (
    <Modal
      animationType="fade"
      onRequestClose={onClose}
      transparent
      visible={visible}
    >
      <Pressable onPress={onClose} style={styles.backdrop}>
        <Pressable onPress={() => {}} style={styles.sheet}>
          {options.map((opt, i) => (
            <View key={i}>
              {i > 0 && <View style={styles.divider} />}
              <Pressable onPress={opt.onPress} style={styles.option}>
                <GText style={styles.optionText}>{opt.label}</GText>
              </Pressable>
            </View>
          ))}
        </Pressable>
      </Pressable>
    </Modal>
  );
}

const styles = StyleSheet.create({
  backdrop: {
    alignItems: "center",
    backgroundColor: colors.darkOverlay,
    flex: 1,
    justifyContent: "center",
  },
  divider: {
    backgroundColor: colors.divider,
    height: 1,
    width: "100%",
  },
  option: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "center",
    paddingVertical: 16,
    width: "100%",
  },
  optionText: {
    color: colors.white,
    fontSize: 17,
    fontWeight: "500",
  },
  sheet: {
    alignItems: "center",
    backgroundColor: colors.sheet,
    borderColor: colors.cardBg,
    borderRadius: 20,
    borderWidth: 1,
    marginHorizontal: 24,
    maxWidth: 600,
    paddingHorizontal: 24,
    paddingVertical: 24,
    width: "100%",
  },
});
